import { withInstall } from '@lit-element/utils'
import Select from './src/select.vue'

import type { SFCWithInstall } from '@lit-element/utils'

export const LtSelectV2: SFCWithInstall<typeof Select> = withInstall(Select)
export default LtSelectV2

export * from './src/token'
